import { BaseButton, type BaseButtonProps } from './BaseButton';
import styles from './PrimaryButton.module.scss';

export function PrimaryButton(props: BaseButtonProps): React.ReactElement {
  const { children, ...restProps } = props;

  return (
    <BaseButton {...restProps} className={styles.primaryButton}>
      {children}
    </BaseButton>
  );
}
